// 型定義の解決が難しかったのでrequireで解決する
const cryptoRandomString = require("crypto-random-string");

class RandomRefkeyStringGenerator {
  public generateUnique(existing: Array<string>): string {
    for (let retryCount = 0; retryCount < 10; retryCount++) {
      const id = this.format(this.generate());
      if (this.checkNoCollision(existing, id)) {
        return id;
      }
    }
    throw new Error("failed to generate new element id.");
  }

  public generateUniqueMyNumberRefKey(existing: Array<string>): string {
    for (let retryCount = 0; retryCount < 10; retryCount++) {
      const id = this.formatMyNumber(this.generate());
      if (this.checkNoCollision(existing, id)) {
        return id;
      }
    }
    throw new Error("failed to generate new element id.");
  }

  public checkNoCollision(existing: Array<string>, newString: string) {
    return existing.indexOf(newString) === -1;
  }

  private format(str: string) {
    // 内部処理的にはPrefixはなくて良いが、開発やDebug時にJSON Documentを見る際に、通常の文字列と見分けをつけられるようにしておく
    return `refKey_file_${str}`;
  }

  private formatMyNumber(str: string) {
    // 内部処理的にはPrefixはなくて良いが、開発やDebug時にJSON Documentを見る際に、通常の文字列と見分けをつけられるようにしておく
    return `refKey_mynumber_${str}`;
  }

  private generate(): string {
    return cryptoRandomString({
      length: 6,
      characters: "0123456789abcdefghijklmnopqrstuvwxyz",
    });
  }
}

export const RefkeyGenerator = new RandomRefkeyStringGenerator();
